export default "<div class=\"footer-inn\">\n    Copyright &#169; 2025 HazardEyeWeb. All rights reserved.\n</div>";